import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Slider as CompoundSlider,
  Rail,
  Handles,
  Tracks,
} from 'react-compound-slider'
import { Box } from 'components/atoms/Layout'
import { math } from 'polished'
import Rails from './components/Rails'
import Handle from './components/Handle'
import Track from './components/Track'
import { HANDLE_SIZE } from './constants'

const Slider = styled(CompoundSlider)`
  position: relative;
  width: 100%;
  touch-action: none;
  user-select: none;
`

const RangeSlider = ({
  step,
  domain,
  onChange,
  onUpdate,
  values,
  isDisabled,
}) => (
  <Box p={`${math(`${HANDLE_SIZE} / 2`)}`}>
    <Slider
      step={step}
      domain={domain}
      onUpdate={onUpdate}
      onChange={onChange}
      values={values}
      disabled={isDisabled}
    >
      <Rail>
        {({ getRailProps }) => (
          <Rails getRailProps={getRailProps} isDisabled={isDisabled} />
        )}
      </Rail>
      <Tracks right={false}>
        {({ tracks, getTrackProps }) => (
          <div>
            {tracks.map(({ id, source, target }) => (
              <Track
                key={id}
                source={source}
                target={target}
                isDisabled={isDisabled}
                {...getTrackProps()}
              />
            ))}
          </div>
        )}
      </Tracks>
      <Handles>
        {({ handles, getHandleProps }) => (
          <div>
            {/* HACK: this wrapper div is needed to prevent weird Slider-sibling margin collapsing messing with handle position */}
            {handles.map((handle) => (
              <Handle
                key={handle.id}
                handle={handle}
                domain={domain}
                isDisabled={isDisabled}
                {...getHandleProps()}
              />
            ))}
          </div>
        )}
      </Handles>
    </Slider>
  </Box>
)

RangeSlider.propTypes = {
  step: PropTypes.number,
  domain: PropTypes.arrayOf(PropTypes.number).isRequired,
  onChange: PropTypes.func,
  onUpdate: PropTypes.func,
  values: PropTypes.arrayOf(PropTypes.number).isRequired,
  isDisabled: PropTypes.bool,
}

RangeSlider.defaultProps = {
  step: 1,
}

export default RangeSlider
